import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { transparentize } from 'polished';
import { Box } from 'roo-ui/components';
import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';

const ReactModalAdapter = ({ className, ...props }) => (
  <ReactModal {...props} className="Modal" overlayClassName="Overlay" portalClassName={className} />
);

const StyledModal = styled(ReactModalAdapter)`
  .Overlay {
    z-index: ${themeGet('zIndices.modalOverlay')};
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: ${({ theme }) => transparentize(0.25, theme.colors.greys.porcelain)};
    display: flex;
    justify-content: center;
    align-items: center;
    animation: ${themeGet('keyframes.fadeIn')} ${themeGet('transitions.quickFadeIn')};
  }

  .Modal {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
    border: none;
    background: ${themeGet('colors.white')};
    overflow: auto;
    border-radius: 0px;
    outline: none;
    padding: 0px;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100vw;

    ${themeGet('mediaQueries.0')} {
      flex: 0 1 ${(props) => themeGet(`maxWidths.${props.width}`)};
      height: auto;
      max-height: 90%;
    }
  }
`;

let modalCount = 0;

class InfoModal extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      id: `modal_${modalCount++}`,
    };
  }

  render() {
    const { contentLabel, title, width, children, disableClose, ...reactModalProps } = this.props;
    const aria = {
      labelledby: `${this.state.id}_labelled_by`,
      describedby: `${this.state.id}_described_by`,
    };
    return (
      <StyledModal contentLabel={contentLabel} aria={aria} role="dialog" width={width} {...reactModalProps}>
        <ModalHeader title={title} onRequestClose={reactModalProps.onRequestClose} aria={aria} disableClose={disableClose} />
        <Box id={aria.describedby}>{children}</Box>
      </StyledModal>
    );
  }
}

InfoModal.propTypes = {
  ...ReactModal.propTypes,
  contentLabel: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.oneOf(['default', 'modal']),
  disableClose: PropTypes.bool,
};

InfoModal.defaultProps = {
  width: 'modal',
  disableClose: false,
};

InfoModal.body = ModalBody;

export default InfoModal;
